exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".book-step2{border-radius:10px;background-color:#fff;width:680px;height:350px;margin-left:calc(50vw - 340px);margin-top:calc(50vh - 175px);box-shadow:8px 8px 15px #bbb;position:relative}.book-step2 .top-grid{position:absolute;left:15px;top:15px}.book-step2 .bottom-grid{position:absolute;bottom:15px;right:15px;width:100px;height:30px}.book-step2 .book-loader{display:flex;justify-content:center;margin-top:35px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/home/book/step2/step2.scss
// module id = 790
// module chunks = 0